import 'aos/dist/aos.css'; // Import the styling definitions
import "./body.css";
import { Link } from "react-router-dom";
import React, { useState, useEffect, Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import Footer from "./footer";
// Import Swiper styles
import "swiper/css";
import Chairman from "../images/Chairman.jpg";
import MainBg from "../images/Leadership main bg.jpg";
import quote from "../images/Title.png";
import Mobilemen from "../images/mobile-men.png";
import withdraw from "../images/withdraw.png";
import group from "../images/group.png";
import payment from "../images/payment.png";
import coin from "../images/coin.png";
import support from "../images/support.png";
import experience from "../images/experience.png";
import dre from "../images/dre.png";
import cliente from "../images/client.png";
import employer from "../images/employer.png";
import enrol from "../images/enrol.png";
import fund from "../images/fund.png";
import invest from "../images/investor.png";
import calc from "../images/calculator.png";
import ppl from "../images/ppl.png";
import program from "../images/programs.png";
import impact from "../images/impact.png";
import mgt from "../images/management.png";
import choose from "../images/rsa-choose.png";
import arrowRight from "../images/arrow.png";
import rsaIcon from "../images/rsa-icon.png";
import homeBanner from "../images/home-banner-1.jpg";
import sure from "../images/surecal.png";
import moment from "moment";
import { GoDotFill } from "react-icons/go";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "swiper/css/navigation";
import AOS from 'aos';


// import required modules
import { Navigation } from "swiper/modules";

import { ApolloClient, HttpLink, InMemoryCache, gql } from "@apollo/client";
import { ApolloProvider } from "@apollo/client/react";

const client = new ApolloClient({
  link: new HttpLink({
    uri: "https://pensure-cms.inspireleadership.biz/graphql",
  }),
  cache: new InMemoryCache(),
});

const Body = () => {
  const [heroBanner, setHeroBanner] = useState([]);
  const [heroMobile, setHeroMobile] = useState([]);
  const [quicklinks, setQuicklinks] = useState([]);
  const [businessSections, setBusinessSections] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [products, setProducts] = useState([]);
  const [allBlogContent, setAllBlogContent] = useState([]);

  window.scrollTo(0, 0);

useEffect(() => {

   AOS.init({
    offset: 0,
    duration: 1000,
    once: true
  });

    
}, [testimonials])
  useEffect(() => {



    client
      .query({
        query: gql`
          query NewQuery {
            pages {
              edges {
                node {
                  id
                  home {
                    hero {
                      buttonLink
                      buttonLink1
                      buttonName
                      buttonName1
                      caption
                      heading
                      image {
                        mediaItemUrl
                      }
                    }
                    heromobile {
                      buttonLink
                      buttonLink1
                      buttonName
                      buttonName1
                      caption
                      heading
                      image {
                        mediaItemUrl
                      }
                    }
                    productInfo {
                      description
                      icon {
                        mediaItemUrl
                      }
                      link
                      name
                    }
                    quicklink {
                      image {
                        mediaItemUrl
                      }
                      link
                      linkName
                    }
                    section {
                      buttonLink
                      buttonName
                      caption
                      heading
                      image {
                        mediaItemUrl
                      }
                      imageBottomCaption
                      imageBottomHeading
                      imageBottomIcon {
                        mediaItemUrl
                      }
                      imageTopCaption
                      imageTopHeading
                      imageTopIcon {
                        mediaItemUrl
                      }
                    }
                    testimonials {
                      feedback
                      name
                    }
                  }
                }
              }
            }
          }
        `,
      })
      .then((result) => {
        console.log(result);

        setHeroBanner(result.data.pages.edges[4].node.home.hero);
        console.log(heroBanner);
        setHeroMobile(result.data.pages.edges[4].node.home.heromobile);
        setQuicklinks(result.data.pages.edges[4].node.home.quicklink);
        setBusinessSections(result.data.pages.edges[4].node.home.section);
        setTestimonials(result.data.pages.edges[4].node.home.testimonials);
        setProducts(result.data.pages.edges[4].node.home.productInfo);

         
      }, ()=> setTimeout(AOS.refresh(), 100) );

    client
      .query({
        query: gql`
          query NewQuery {
            blog(first: 2) {
              edges {
                node {
                  id
                  categories {
                    nodes {
                      databaseId
                      name
                    }
                  }
                  blogs {
                    body {
                      contentarea
                      image {
                        mediaItemUrl
                      }
                      list {
                        items
                        images {
                          mediaItemUrl
                        }
                      }
                      subheading
                      text
                      textcontent
                    }
                    coverImage {
                      mediaItemUrl
                    }
                    heading
                  }
                  date
                }
              }
            }
          }
        `,
      })
      .then((result) => {
        console.log(result.data.blog);
        setAllBlogContent(result.data.blog.edges);
      });
  }, []);

  let heroBannerDisplay;
  let heroMobileBannerDisplay;
  let quicklinksDisplay;
  let businessSectionsDisplay;
  let testimonialsDisplay;
  let productsDisplay;
  let productsMobileDisplay;

  if (heroBanner.length > 0) {
    heroBannerDisplay = heroBanner.map((banner, i) =>
      banner.buttonName1 != null ? (
        <SwiperSlide>
          <div className="body-cover">
            <img className="body-bg" src={banner.image.mediaItemUrl} />
            <div className="body-content">
              <div className="body-txt">
                <h1 className="body-h1 ">{banner.heading}</h1>
                <p className="grey-p-body">{banner.caption}</p>
                <div className="d-flex mobile-block gapping align-items-center">
                  <a href={banner.buttonLink} className="btn-trns-white mb-3">
                    {" "}
                    {banner.buttonName}{" "}
                    <FontAwesomeIcon
                      icon={faArrowRight}
                      className="grey-arrw"
                    />
                  </a>
                  <a href={banner.buttonLink1} className="btn-trns mb-3">
                    {" "}
                    {banner.buttonName1}{" "}
                    <FontAwesomeIcon
                      icon={faArrowRight}
                      className="grey-arrw"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </SwiperSlide>
      ) : (
        <SwiperSlide>
          <div className="body-cover">
            <img className="body-bg" src={banner.image.mediaItemUrl} />
            <div className="body-content">
              <div className="body-txt">
                <h1 className="body-h1 ">{banner.heading}</h1>
                <p className="grey-p-body">{banner.caption}</p>
                <div className="d-flex mobile-block gapping align-items-center">
                  <a href={banner.buttonLink} className="btn-trns mb-3">
                    {" "}
                    {banner.buttonName}{" "}
                    <FontAwesomeIcon
                      icon={faArrowRight}
                      className="grey-arrw"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </SwiperSlide>
      ),
    );
  }

  if (heroMobile.length > 0) {
    heroMobileBannerDisplay = heroMobile.map((banner, i) =>
      banner.buttonName1 != null ? (
        <SwiperSlide>
          <div className="body-cover">
            <img className="body-bg" src={banner.image.mediaItemUrl} />
            <div>
              <div className="body-content">
                <div className="contentPosition">
                  <div className="body-txt-mob">
                    <h1 className="body-h1 ">{banner.heading}</h1>
                    <p className="grey-p-body">{banner.caption}</p>
                  </div>
                  <div className="d-flex mobile-block gapping align-items-center body-txt-mob-1">
                    <a href={banner.buttonLink} className="btn-trns-white mb-3">
                      {" "}
                      {banner.buttonName}{" "}
                      <FontAwesomeIcon
                        icon={faArrowRight}
                        className="grey-arrw"
                      />
                    </a>
                    <a href={banner.buttonLink1} className="btn-trns mb-3">
                      {" "}
                      {banner.buttonName1}{" "}
                      <FontAwesomeIcon
                        icon={faArrowRight}
                        className="grey-arrw"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </SwiperSlide>
      ) : (
        <SwiperSlide>
          <div className="body-cover">
            <img className="body-bg" src={banner.image.mediaItemUrl} />
            <div>
              <div className="body-content">
                <div className="contentPosition">
                  <div className="body-txt-mob">
                    <h1 className="body-h1 ">{banner.heading}</h1>
                    <p className="grey-p-body">{banner.caption}</p>
                  </div>
                  <div className="d-flex mobile-block gapping align-items-center body-txt-mob-1">
                    <a href={banner.buttonLink1} className="btn-trns mb-3">
                      {" "}
                      {banner.buttonName1}{" "}
                      <FontAwesomeIcon
                        icon={faArrowRight}
                        className="grey-arrw"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </SwiperSlide>
      ),
    );
  }

  if (quicklinks.length > 0) {
    quicklinksDisplay = quicklinks.map((links, i) => (
      <figure className="tool-width align-items-center" data-aos="zoom-in" data-aos-delay="200"  onLoad={() => AOS.refresh()}>
        <Link to={links.link} className="no-decoration-home tool-width-mob">
          <img
            className="pb-4 tool-img"
            src={links.image.mediaItemUrl}
            width="25%"
          />

          <figcaption className="mt-2">
            <p className="white-p-body-2 revert-margin">{links.linkName}</p>
          </figcaption>
        </Link>
      </figure>
    ));

      AOS.refresh();
  }

  if (testimonials.length > 0) {
    testimonialsDisplay = testimonials.map((testimonial, i) => (
      <SwiperSlide className="body-crd-test text-start">
        <figure className="pb-1">
          <figcaption>
            <p
              className="card-text pt-2 pb-2 grey-p-body"
              style={{ fontSize: "16px" }}
            >
              {testimonial.feedback}
            </p>

            <div className="d-flex align-items-center  test-gap mt-5">
              <div>
                <h4 className="card-subtitle statements-hdr-body">
                  {testimonial.name}.
                </h4>
              </div>
              <div className="">
                <img src={quote} className="img-fluid" width="60%" />
              </div>
            </div>
          </figcaption>
        </figure>
      </SwiperSlide>
    ));
  }

  if (products.length > 0) {
    productsMobileDisplay = products.map((product, i) => (
      <Link to={product.link} className="no-decoration-home">
        <div className="body-crd-mob text-start mb-3 mx-auto">
          <figure className="pb-5">
            <img className="pb-4" src={product.icon.mediaItemUrl} width="15%" />
            <figcaption>
              <h4 className="card-subtitle mb-1 statements-hdr-body whiteText">
                {product.name}
              </h4>
              <p
                className="card-text pt-2 grey-p-body textHeight"
                style={{ fontSize: "16px" }}
              >
                {product.description}
              </p>
            </figcaption>
          </figure>

          <hr
            className="mt-5"
            style={{
              border: "0",
              borderTop: "0.1px dashed #e9e8e8ff",
              borderImage:
                "repeating-linear-gradient(to right, #d1cfcfff 0, #d1cfcfff 4px, transparent 4px, transparent 8px) 1",
            }}
          />
          <div className="Read-more gapping d-flex align-items-center">
            <FontAwesomeIcon
              className="chv-dwn-arr "
              icon={faArrowRight}
              style={{
                color: "#ffffff",
                fontSize: "8px",
                fontWeight: "light",
                backgroundColor: "rgba(255, 255, 255, 0.2)",
                padding: "13.5px",
              }}
            />{" "}
            <span class=" ms-2 white-p-body" style={{ fontWeight: "500" }}>
              {" "}
              Learn More{" "}
            </span>
          </div>
        </div>
      </Link>
    ));

    productsDisplay = products.map((product, i) => (
      <SwiperSlide className="body-crd text-start">
        <Link to={product.link} className="no-decoration">
          <figure className="pb-5">
            <img className="pb-4" src={product.icon.mediaItemUrl} width="15%" />
            <figcaption>
              <h4 className="card-subtitle mb-1 statements-hdr-body whiteText">
                {product.name}{" "}
              </h4>
              <p
                className="card-text pt-2 grey-p-body textHeight"
                style={{ fontSize: "16px" }}
              >
                {product.description}
              </p>
            </figcaption>
          </figure>

          <hr
            className="mt-5"
            style={{
              border: "0",
              borderTop: "0.1px dashed #e9e8e8ff",
              borderImage:
                "repeating-linear-gradient(to right, #d1cfcfff 0, #d1cfcfff 4px, transparent 4px, transparent 8px) 1",
            }}
          />
          <div className="Read-more gapping d-flex align-items-center">
            <FontAwesomeIcon
              className="chv-dwn-arr "
              icon={faArrowRight}
              style={{
                color: "#ffffff",
                fontSize: "8px",
                fontWeight: "light",
                backgroundColor: "rgba(255, 255, 255, 0.2)",
                padding: "13.5px",
              }}
            />{" "}
            <span class=" ms-2 white-p-body" style={{ fontWeight: "500" }}>
              {" "}
              Learn More{" "}
            </span>
          </div>
        </Link>
      </SwiperSlide>
    ));
  }

  if (businessSections.length > 0) {
    businessSectionsDisplay = businessSections.map((section, i) =>
      i % 2 ? (
        <div
          id="mobile-view"
          className=" d-flex align-items-center justify-content-between padding-section-standard-top-body pb-5"
        >
          <div className="d-flex d-none d-md-block justify-content-end">
            <div className="abs-pos-perf-1-desk align-items-center d-flex white-bg-hang hang-shadow"  data-aos="fade-left" data-aos-delay="100">
              <div>
                <img
                  className="img-fluid"
                  src={section.imageTopIcon.mediaItemUrl}
                  width="70%"
                />
              </div>
              <div>
                <figure className="csr-tag-heading">
                  {section.imageTopHeading}+
                  <figcaption className="csr-tag-text mt-1">
                    {section.imageTopCaption}
                  </figcaption>
                </figure>
              </div>
            </div>
            <img className="img-fluid" src={section.image.mediaItemUrl} />

            <div className="abs-pos-perf-2-desk align-items-center d-flex white-bg-hang hang-shadow"  data-aos="fade-right" data-aos-delay="100">
              <div>
                <img
                  className="img-fluid"
                  src={section.imageBottomIcon.mediaItemUrl}
                  width="70%"
                />
              </div>
              <div>
                <figure className="csr-tag-heading">
                 &#8358; {section.imageBottomHeading}
                  <figcaption className="csr-tag-text mt-1">
                    {section.imageBottomCaption}
                  </figcaption>
                </figure>
              </div>
            </div>
          </div>

          <div className="values compact-section-body-1"  data-aos="fade-up" data-aos-delay="100">
            <h3 className="body-h3-1"> {section.heading} </h3>
            <p
              className="grey-p pt-3 pb-3"
              style={{ fontSize: "16px", color: "#545454" }}
            >
              {section.caption}
            </p>

            <Link class="open-acc-btn grey-p mt-3" to={section.buttonLink}>
              {section.buttonName}{" "}
              <FontAwesomeIcon className="body-dwn-arr" icon={faArrowRight} />
            </Link>
          </div>

          <div className="d-block d-md-none justify-content-end">
            <div className="abs-pos-perf-1-desk align-items-center d-flex white-bg-hang hang-shadow"  data-aos="fade-left" data-aos-delay="100">
              <div>
                <img
                  className="img-fluid"
                  src={section.imageTopIcon.mediaItemUrl}
                  width="70%"
                />
              </div>
              <div>
                <figure className="csr-tag-heading">
                  {section.imageTopHeading}
                  <figcaption className="csr-tag-text mt-1">
                    {section.imageTopCaption}
                  </figcaption>
                </figure>
              </div>
            </div>
            <img className="img-fluid" src={section.image.mediaItemUrl} />

            <div className="abs-pos-perf-2-desk align-items-center d-flex white-bg-hang hang-shadow"  data-aos="fade-right" data-aos-delay="100">
              <div>
                <img
                  className="img-fluid"
                  src={section.imageBottomIcon.mediaItemUrl}
                  width="70%"
                />
              </div>
              <div>
                <figure className="csr-tag-heading">
                  {section.imageBottomHeading}
                  <figcaption className="csr-tag-text mt-1">
                    {section.imageBottomCaption}
                  </figcaption>
                </figure>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div
          id="mobile-view"
          className=" d-flex align-items-center justify-content-between padding-section-standard-top-body pb-5"
        >
          <div className="values compact-section-body"  data-aos="fade-up" data-aos-delay="100">
            <h3 className="body-h3-1"> {section.heading} </h3>
            <p
              className="grey-p pt-3 pb-3"
              style={{ fontSize: "16px", color: "#545454" }}
            >
              {section.caption}
            </p>

            <Link className="open-acc-btn grey-p mt-3" to={section.buttonLink}>
              {section.buttonName}{" "}
              <FontAwesomeIcon className="body-dwn-arr" icon={faArrowRight} />
            </Link>
          </div>

          <div className="justify-content-end">
            <div className="abs-pos-csr-1-desk align-items-center d-flex white-bg-hang hang-shadow"  data-aos="fade-right" data-aos-delay="100">
              <div>
                <img
                  className="img-fluid"
                  src={section.imageTopIcon.mediaItemUrl}
                  width="70%"
                />
              </div>
              <div>
                <figure className="csr-tag-heading">
                  {section.imageTopHeading}
                  <figcaption className="csr-tag-text mt-1">
                    {section.imageTopCaption}
                  </figcaption>
                </figure>
              </div>
            </div>
            <img className="img-fluid" src={section.image.mediaItemUrl} />

            <div className="abs-pos-csr-2-desk align-items-center d-flex white-bg-hang-2 hang-shadow"  data-aos="fade-left" data-aos-delay="100">
              <div>
                <img
                  className="img-fluid"
                  src={section.imageBottomIcon.mediaItemUrl}
                  width="70%"
                />
              </div>
              <div>
                <figure className="csr-tag-heading">
                  {section.imageBottomHeading}
                </figure>
              </div>
              <div>
                <figure className="csr-tag-heading">
                  <figcaption className="csr-tag-text mt-1">
                    {section.imageBottomCaption}
                  </figcaption>
                </figure>
              </div>
            </div>
          </div>
        </div>
      ),
    );
  }

  if (heroBanner.length > 0) {
      AOS.refresh();
    return (
      <>
        <div className="body-container d-none d-sm-block">
          <Swiper
            navigation={true}
            modules={[Navigation]}
            spaceBetween={0}
            loop={true}
            slidesPerView={1}
            onSlideChange={() => console.log("slide change")}
            onSwiper={(swiper) => console.log(swiper)}
            className="hero"
          >
            {heroBannerDisplay}
          </Swiper>
        </div>

        <div className="body-container d-block d-sm-none">
          <Swiper
            navigation={true}
            modules={[Navigation]}
            spaceBetween={0}
            loop={true}
            slidesPerView={1}
            onSlideChange={() => console.log("slide change")}
            onSwiper={(swiper) => console.log(swiper)}
            className="hero"
          >
            {heroMobileBannerDisplay}
          </Swiper>
        </div>

        <div className="d-flex mobile-block tool-bar align-items-center justify-space-between text-center mb-5" >
          {quicklinksDisplay}
        </div>

        <div className="containeer pt-5">
          <div
            id="mobile-view"
            className=" d-flex align-items-center justify-content-between pt-5 pb-5  mobile-view-body"
          >
            <div className="values entry-text-pad">
              <h6 className="orange-p-body pb-2 "data-aos="fade-in" data-aos-delay="50"> ABOUT LEADWAY PFA </h6>
              <h3 className="body-h3 pb-3"data-aos="fade-up" data-aos-delay="200">
                We are your trusted PFA, committed to providing excellent
                service to you at all times.
              </h3>
              <p
                className="grey-p-body mb-4"
                style={{ fontSize: "16px", color: "#545454" }}
             data-aos="fade-up" data-aos-delay="100" >
                For over 20 years, we have supported individuals, corporate
                organizations, entrepreneurs, and both state and federal
                institutions with secure, transparent, and expertly managed
                financial portfolios
              </p>

              <div className="d-flex gapping" data-aos="fade-up" data-aos-delay="100" >
                <div className="half-width d-flex align-items-center">
                  <Link
                    className="card-text orange-p-body-3 align-items-center"
                    to="/about-us"
                  >
                    Learn more about us
                  </Link>
                  <img src={arrowRight} className="padding-left" />
                </div>
                <div className="half-width d-flex align-items-center">
                  <Link
                    className="card-text orange-p-body-3 align-items-center"
                    to="/leadership"
                  >
                    See our leadership
                  </Link>
                  <img src={arrowRight} className="padding-left" />
                </div>
              </div>
              <div
                id="mobile-view"
                className=" d-flex justify-content-between pt-5"
              >
                <div className="mt-5">
                  <div className="card body-crd-1 ">
                    <div className=" d-flex flex-column gap-3 crd-bdy mobile-center">
                      <h4 className="body-h4 grey-color ">470B+</h4>

                      <div className="d-flex align-items-center mobile-block mobile-center">
                        <p className="grey-p-body grey-color">
                          {" "}
                          Assets Managed{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mt-5">
                  <div className="card body-crd-1">
                    <div className=" d-flex flex-column gap-3 crd-bdy mobile-center">
                      <h4 className="body-h4 grey-color ">750K+</h4>

                      <div className="d-flex align-items-center mobile-block mobile-center">
                        <p className="grey-p-body grey-color"> RSA Holders </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mt-5">
                  <div className="card body-crd-1">
                    <div className=" d-flex flex-column gap-3 crd-bdy mobile-center">
                      <h4 className="body-h4 grey-color ">20+ Years</h4>

                      <div className="d-flex mobile-block align-items-center  mobile-center">
                        <p className="grey-p-body grey-color">
                          {" "}
                          Of Experience{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex ldr-section" style={{ width: "113%" }}>
              <div className="card ldr-crd text-start">
                <figure className="compact-settings-body-works">
                  <figcaption></figcaption>
                </figure>
              </div>
            </div>
          </div>
        </div>

        <div className="plain-cont">
          <div
            id="mobile-view"
            className=" row d-flex justify-content-between text-center full-width"
          >
            <div className="text-center pb-5">
              <p className="orange-p-body pb-2" data-aos="fade-up" data-aos-delay="100" >OUR SERVICES</p>
              <h2 className="body-h2 dark-text pb-1 " data-aos="fade-up" data-aos-delay="100" >
                Pension Plans Designed for You
              </h2>
              <p className="grey-p-mf dark-text-2" data-aos="fade-up" data-aos-delay="100" >
                Explore our tailored retirement savings options
              </p>
            </div>
            <div id="mobile-view" className="d-flex justify-content-between" data-aos="fade-up" data-aos-delay="200" >
              <div className="d-block d-sm-none">{productsMobileDisplay}</div>

              <Swiper
                navigation={true}
                modules={[Navigation]}
                spaceBetween={50}
                loop={true}
                slidesPerView="auto"
                onSlideChange={() => console.log("slide change")}
                onSwiper={(swiper) => console.log(swiper)}
                className="services d-none d-sm-block"
              >
                {productsDisplay}
                ...
              </Swiper>
            </div>
          </div>
        </div>

        <div className="containeer">{businessSectionsDisplay}</div>

        <div className="black-cont-body">
          <div
            id="mobile-view"
            className="containeer benefit-gap  d-flex justify-content-between "
          >
            <div className="slider-divv-head pb-5">
              <p className="orange-p">HOW IT WORKS</p>
              <h2 className="body-h2" style={{ color: "#FFFFFF" }}>
                Explore How Our Plans <br /> Support You
              </h2>
            </div>
            <div className="slider-divv">
              <div className="d-flex mobile-block work-gap justify-space-between">
                <figure className="pb-5 work-width "  data-aos="fade-up" data-aos-delay="100">
                  <img className="pb-4" src={withdraw} width="7%" />
                  <figcaption className="pb-4">
                    <h4 className="card-subtitle mb-1 statements-hdr-body white-text">
                      Possible Reasons For Withdrawal
                    </h4>
                    <p
                      className="card-text pt-2 grey-p-body"
                      style={{ fontSize: "16px" }}
                    >
                      From retirement to medical or relocation needs, we help
                      you access your pension when the time is right.
                    </p>
                  </figcaption>
                  <Link
                    className="card-text orange-highlight d-flex align-items-center mt-2"
                    to="/services/withdrawal"
                  >
                    See Eligible Conditions
                    <img src={arrowRight} className="padding-left" />
                  </Link>
                </figure>

                <figure className="pb-5 work-width"  data-aos="fade-up" data-aos-delay="100">
                  <img className="pb-4" src={group} width="7%" />
                  <figcaption className="pb-4">
                    <h4 className="card-subtitle mb-1 statements-hdr-body white-text">
                      Unpaid Grouplife and Accrued Right
                    </h4>
                    <p
                      className="card-text pt-2 grey-p-body"
                      style={{ fontSize: "16px" }}
                    >
                      Beneficiaries can claim unpaid group life insurance or
                      accrued rights left in RSA accounts.
                    </p>
                  </figcaption>

                  <Link
                    className="card-text orange-highlight d-flex align-items-center mt-2"
                    to="/services/group-life"
                  >
                    View Claim Process
                    <img src={arrowRight} className="padding-left" />
                  </Link>
                </figure>
              </div>

              <div className="d-flex mobile-block work-gap justify-space-between"  data-aos="fade-up" data-aos-delay="100">
                <figure className="pb-5 work-width">
                  <img className="pb-4" src={coin} width="7%" />
                  <figcaption className="pb-4">
                    <h4 className="card-subtitle mb-1 statements-hdr-body white-text">
                      Uncredited Contributions/Funds
                    </h4>
                    <p
                      className="card-text pt-2 grey-p-body"
                      style={{ fontSize: "16px" }}
                    >
                      Search and reclaim pension deductions that were never
                      credited to your RSA account.
                    </p>
                  </figcaption>
                  <Link
                    className="card-text orange-highlight d-flex align-items-center mt-2"
                    to="/services/unpaid-credit"
                  >
                    Search & Reclaim Funds
                    <img src={arrowRight} className="padding-left" />
                  </Link>
                </figure>

                <figure className="pb-5 work-width"  data-aos="fade-up" data-aos-delay="100">
                  <img className="pb-4" src={payment} width="7%" />
                  <figcaption className="pb-4">
                    <h4 className="card-subtitle mb-1 statements-hdr-body white-text">
                      Payment Types
                    </h4>
                    <p
                      className="card-text pt-2 grey-p-body"
                      style={{ fontSize: "16px" }}
                    >
                      Choose how you want your pension paid. lump sum,
                      programmed withdrawal, or annuity.
                    </p>
                  </figcaption>

                  <Link
                    className="card-text orange-highlight d-flex align-items-center mt-2"
                    to="/services/payment-types"
                  >
                    Explore Payment Options
                    <img src={arrowRight} className="padding-left" />
                  </Link>
                </figure>
              </div>
            </div>
          </div>
        </div>

        <div className="plain-cont">
          <div
            id="mobile-view"
            className="row d-flex justify-content-between text-center full-width"
          >
            <div className="text-center pb-5">
              <p className="orange-p-body pb-2"  data-aos="fade-up" data-aos-delay="100">WHAT OUR CLIENTS SAY </p>
              <h2 className="mf-h2 dark-text"  data-aos="fade-up" data-aos-delay="100">Client Testimonials</h2>
            </div>
            <div id="mobile-view" className="d-flex justify-content-between"  data-aos="fade-in" data-aos-delay="200">
              <Swiper
                navigation={true}
                modules={[Navigation]}
                spaceBetween={1}
                loop={true}
                slidesPerView="auto"
                onSlideChange={() => console.log("slide change")}
                onSwiper={(swiper) => console.log(swiper)}
                className="services full-width"
              >
                {testimonialsDisplay}
              </Swiper>
            </div>
          </div>
        </div>

        <div className="plain-cont">
          <div
            id="mobile-view"
            className="containeer row d-flex justify-content-between "
          >
            <div className="text-center pb-5 text-center">
              <p className="orange-p-body pb-2"  data-aos="fade-up" data-aos-delay="100">LATEST UPDATES</p>
              <h2 className="body-h2 dark-text pb-1"  data-aos="fade-up" data-aos-delay="100">Whats New At Leadway</h2>
              <p className="grey-p-body dark-text-2"  data-aos="fade-up" data-aos-delay="100">
                Catch up on updates, tips, and news that matter to you.
              </p>
            </div>

            <div className="otherItems"  data-aos="fade-in" data-aos-delay="100">
              {allBlogContent.map((item) => {
                return (
                  <Link
                    to={`/blog-single/${item.node.id}`}
                    key={item.node.id}
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    <div id="innerblog-crd" className=" crd card ">
                      <div style={{ padding: "0.64rem" }}>
                        <div
                          id="crd-top"
                          style={{
                            width: "200px",
                            backgroundImage: `url(${item.node.blogs.coverImage.mediaItemUrl})`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            borderRadius: "0.5rem",
                            height: "215px",
                          }}
                        ></div>
                      </div>

                      <div id="inner-body" className="card-body">
                        <p className="mb-3 p-head">
                          {" "}
                          {item.node.categories.nodes[0].name}{" "}
                        </p>
                        <h5
                          className="card-title crd-ttl "
                          style={{
                            fontSize: "18px !important",
                            fontWeight: "500",
                          }}
                        >
                          {item.node.blogs.heading}
                        </h5>
                        <p
                          className="card-text crd-txt mt-2"
                          style={{ fontWeight: "500" }}
                        >
                          {moment(item.node.date).format("MMM Do YYYY")}
                          <GoDotFill
                            className="ms-1 me-1"
                            style={{ fontSize: "8px" }}
                          />
                          {item.node.categories.nodes[0].name}
                        </p>
                        <hr
                          style={{
                            border: "0",
                            borderTop: "2px dashed #e9e8e8ff",
                            borderImage:
                              "repeating-linear-gradient(to right, #d1cfcfff 0, #d1cfcfff 4px, transparent 4px, transparent 8px) 1",
                          }}
                        />
                        <div className="Read-more d-flex align-items-center">
                          <FontAwesomeIcon
                            className="chv-dwn-arr "
                            icon={faArrowRight}
                            style={{
                              color: "#fe7914",
                              fontSize: "8px",
                              fontWeight: "light",
                              backgroundColor: "#FFEACC",
                              padding: "13.5px",
                            }}
                          />{" "}
                          <span class="lrn-more ms-2"> Learn More </span>
                        </div>
                      </div>
                    </div>
                  </Link>
                );
              })}
            </div>
          </div>
          <div
            id="mobile-view"
            className="d-flex justify-content-between"
          ></div>
              <Footer/>
              <div className='height'> 

              </div>
        </div>
   
      </>
      
    );
  }
};

export default Body;
